<template>
  <div class="btns" style="margin-top:20px;">
    <Button @click="call" icon="ios-call-outline" v-if="canCall">
      呼叫
    </Button>
    <Button @click="toAudit" Icon="md-add" type="success" :disabled="disable" v-if="$checkAuth(auditForm.menu_code)">
      审核
    </Button>
    <Button @click="rollback">
      返回
    </Button>
    <Modal v-model="auditModel" title="审核">
      <Form ref="form" :model="form" label-position="top">
        <FormItem label="备注:" prop="remark">
          <Input v-model.trim="form.remark"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="audit('01')">通过</Button>
        <Button @click="audit('02')">拒绝</Button>
      </div>
    </Modal>
  </div>
</template>

<script type="text/ecmascript-6">
const COMP_NAME = 'DsAudit'
// auditForm: {
//   src_id: this.id,
//   busi_type: 'auditing.prd',
//   menu_code: this.$Actions.prd.prdAudit.do,
//   menu_code_call: this.$Actions.prd.prdAudit.do,
//   rollback_url: '/prdtemp/to',
//   cust_id: ''
// }
export default {
  name: COMP_NAME,
  props: {
    auditForm: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      form: {
        src_id: this.auditForm.src_id,
        busi_type: this.auditForm.busi_type,
        opt_code: '',
        remark: '',
        cust_id: ''
      },
      disable: false,
      auditModel: false
    }
  },
  computed: {
    canCall: {
      get: function () {
        if (!this.$checkAuth(this.auditForm.menu_code_call)) {
          return false
        }
        if (this.auditForm.cust_id !== null || this.auditForm.cust_id !== '') {
          return false
        }
      },
      set: function () {
        if (this.auditForm.cust_id !== null && this.auditForm.cust_id !== '') {
          this.form.cust_id = this.auditForm.cust_id
          return true
        }
      }
    }
  },
  methods: {
    call () {
      this.$setAuth(this.auditForm.menu_code_call)
      this.$axios.post(this.$URLS.custCall, { id: this.form.cust_id })
    },
    rollback () {
      this.$router.push(this.auditForm.rollback_url)
    },
    toAudit () {
      this.auditModel = true
    },
    audit (optCode) {
      // 审核拒绝
      if (optCode === '02' && this.form.remark === '') {
        this.$Notice.error({
          title: '审核拒绝, 必须填写备注'
        })
        return
      }
      this.form.opt_code = optCode
      this.$setAuth(this.auditForm.menu_code)
      this.$axios.post(this.$URLS.audit, this.form).then(() => {
        this.auditModel = false
        this.disable = true
        this.rollback()
      })
    }
  }
}
</script>

<style type="text/stylus" scoped lang="stylus" rel="stylesheet/stylus"></style>



// WEBPACK FOOTER //
// src/components/dsaudit/DsAudit.vue